var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"container-fluid"},[_c('location-form',{attrs:{"loading":_vm.loading,"locationData":_vm.location,"formErrors":_vm.formErrors},on:{"locationSubmitted":_vm.handleSubmit,"formChanged":() => (_vm.alertLeave = true)}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }